import React, {Component} from 'react';
import PropTypes from "prop-types";
import Types from "../../../../../../General/Types";
import TreeView from "../../../../../../../components/common/TreeView";

class DropDownMultiSelect extends Component {
    static propTypes = {
        onChange: PropTypes.func,
        permissions: PropTypes.object,
        rolePermissions: PropTypes.object,
        defaultValue: PropTypes.array,
    };
    static defaultProps = {
        onChange: ()=>{},
        permissions: undefined,
        rolePermissions: undefined,
        defaultValue: undefined,
    };

    constructor(props) {
        super(props);
        this.state={
            rules: Types.items('WorkingHour.Rules'),
        }
    }

    createChildren = (nodes, level = 0, checkedNodesIds) => {
        let data = [];
        if (nodes && nodes.children && nodes.children[0]) {
            nodes.children.map((node, index) =>  {
                let key = {};
                key[`${node.name}`] = node.id;
                data.push({
                    title: node.label,
                    // checked: checkedNodesIds.includes(node._id),
                    key: node.id,
                    name: node.name,
                    // className: 'tree-level tree-level-'+level +(node.type === "node" ?' bold-text': ''),
                    children: this.createChildren(node, level + 1, checkedNodesIds)
                });
            });
        }
        return data;
    };

    createNodes = (nodes, checkedNodesIds)=>{
        return [{
            title: 'همه',
            key: 'all',
            // checked: checkedNodesIds.includes(nodes._id),
            // expanded: true,
            children: this.createChildren({children: nodes}, 1 , checkedNodesIds)
        }]
    }

    render() {
        let {rules} = this.state;
        let {onChange, defaultValue} = this.props;
        return (

                <TreeView
                    titleKeys={['title']}
                    nodeKey={'key'}
                    childrenKey={'children'}
                    // title={app.translate('routes.home.basic.permission.Permissions')}
                    checkable
                    treeData={this.createNodes(rules)}
                    // defaultCheckedKeys={defaultCheckedKeys}
                    // defaultSelectedKeys={defaultCheckedKeys}
                    // defaultExpandedKeys={['0']}
                    // checkAllButton
                    ref={(input) => this.treeView = input}
                    jsSearch={false}
                    defaultCheckedKeys={defaultValue}
                    // titleKeys={['title']}
                    // nodeKey={'key'}

                    // checkable
                    onCheck={(e)=>{
                        let factors = {};
                        e.forEach((typeId)=>{
                            let foundType = Types.findId( Number.parseInt(typeId) );
                            if(foundType)
                                factors[foundType.name] = foundType.id;
                        })
                        // console.log('e', e)
                        // console.log( Types.findId( Number.parseInt(e[0]) ) )
                        onChange(factors)
                    }}
                    // title={ app.translate('routes.home.attendance.reports.Report columns')}
                    // showSearch={false}
                    // treeData={this.createChildren(rules, 0 , [])}
                    // defaultCheckedKeys={this._selected}
                    // checkAllButton={checkAll}
                    // treeStyle={{height: 'calc(100% - 44px)'}}
                    // ref={(input) => this.treeView = input}
                />
        );
    }
}

export default DropDownMultiSelect;